import * as React from 'react';

function useHandleScrollEffect(isVisible: boolean, isSmallScreen: boolean, suggestions: any[]): void {
    React.useEffect(() => {
        if (isVisible) {
            if (isSmallScreen) {
                document.querySelector('header').classList.add('height-100');
            }

            if (suggestions.length) {
                document.body.classList.add('scroll-disable');
            } else {
                document.body.classList.remove('scroll-disable');
            }

            return;
        }

        document.body.classList.remove('scroll-disable');
        document.querySelector('header').classList.remove('height-100');
    }, [isVisible, suggestions.length])
}

export default useHandleScrollEffect;
